import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import {Link} from "react-router-dom";

function nameColumn(cell, row) {
  return `${row.first_name} ${row.last_name}`;
}

class RegistrationRequestList extends Component<any, any> {

  constructor(props) {
    super(props);
    this.renderActionButton = this.renderActionButton.bind(this);
  }

  renderActionButton(val, row) {
    return <Link to={`/settings/users/add/${row.registrationRequestId}`}>Create User</Link>
  }

  render() {
    return (
      <div>
        <BootstrapTable data={this.props.requests} headerStyle={{background: '#DFECF5'}}
                        tableContainerClass={'wa-bootstrap-table-container'} keyField={"registrationRequestId"}>
          <TableHeaderColumn width="55" className="headerColumnColor" dataAlign="center"
                             dataFormat={nameColumn}>
            Name
          </TableHeaderColumn>
          <TableHeaderColumn width="55" className="headerColumnColor" dataAlign="center" dataField="company">
            Company
          </TableHeaderColumn>
          <TableHeaderColumn width="55" className="headerColumnColor" dataAlign="center" dataField="email">
            Email
          </TableHeaderColumn>
          <TableHeaderColumn width="55" className="headerColumnColor" dataField="message">
            Message
          </TableHeaderColumn>
          <TableHeaderColumn width="55" className="headerColumnColor" dataAlign="center"
                             dataFormat={this.renderActionButton}>
            Email
          </TableHeaderColumn>
        </BootstrapTable>
      </div>
    );
  }
}

export default RegistrationRequestList;
